import Vue from "vue";
import Router from "vue-router";
import store from "./app-state";

import { PageNotFound } from "./shared/components";
import clientRoutes from "@/app/client/client-routes";
import adminRoutes from "@/app/admin/admin-routes";
import mobileRoutes from "@/app/mobile/client-routes";
import * as helpers from "@/app/shared/services/helpers";
import { RouterHooks } from "@/app/shared/services/app-router/hooks";

function routes() {
    if (helpers.isMobile()) {
        return mobileRoutes;
    } else {
        return clientRoutes;
    }
}

const baseRoutes = [
    {
        path: "/",
        redirect: store.getters.IS_ADMIN ? "/admin" : "/panel",
    },
    {
        path: "/404",
        name: "Page404",
        component: PageNotFound,
    },
];

Vue.use(Router);
const router = new Router({
    mode: "history",
    routes: [
        ...baseRoutes,
        ...adminRoutes,
        ...routes(),
        {
            path: "*",
            redirect: "/404",
        },
    ],
});

router.beforeEach(RouterHooks.setTestGroup);
router.beforeEach(RouterHooks.setApplicationTitle);
router.beforeEach(RouterHooks.setApplicationFavicon);

export default router;
